import React from "react";

const AddressForm = ({
    onUserDetailSave,
    handleChange,
    formData,
    loading,
    handleBackToAddresses,
    isEditMode,
    countryOptions = [],
}) => {
    const finalCountryOptions = formData.country && !countryOptions.includes(formData.country)
        ? [formData.country, ...countryOptions]
        : countryOptions;

    return (
        <div>
            <div className="box-border">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-white fw-semibold">
                        {isEditMode ? "Edit Address" : "Add New Address"}
                    </span>
                    {handleBackToAddresses && (
                        <button type="button" className="web_buttons" onClick={handleBackToAddresses}>
                            Back
                        </button>
                    )}
                </div>

                <form onSubmit={onUserDetailSave}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="text-white mb-1">Name *</label>
                            <input
                                type="text"
                                name="contact_person_name"
                                className="form-control"
                                value={formData.contact_person_name}
                                onChange={handleChange}
                                placeholder="Enter full name"
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="text-white mb-1">Phone *</label>
                            <input
                                type="text"
                                name="phone"
                                className="form-control"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Enter phone number"
                                maxLength={15}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="text-white mb-1">ZIP / PIN Code *</label>
                            <input
                                type="text"
                                name="zip"
                                className="form-control"
                                value={formData.zip}
                                onChange={handleChange}
                                placeholder="Enter ZIP / postal code"
                                maxLength={12}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="text-white mb-1">Country *</label>
                            <select
                                name="country"
                                className="form-control custom-select"
                                value={formData.country}
                                onChange={handleChange}
                            >
                                <option value="">Select country</option>
                                {finalCountryOptions.map((country) => (
                                    <option key={country} value={country}>
                                        {country}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="text-white mb-1">State *</label>
                            <input
                                type="text"
                                name="state"
                                className="form-control"
                                value={formData.state || ""}
                                onChange={handleChange}
                                placeholder="State"
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="text-white mb-1">City *</label>
                            <input
                                type="text"
                                name="city"
                                className="form-control"
                                value={formData.city}
                                onChange={handleChange}
                                placeholder="City"
                            />
                        </div>

                        <div className="col-12 mb-3">
                            <label className="text-white mb-1">Address *</label>
                            <textarea
                                name="address"
                                className="form-control"
                                value={formData.address}
                                onChange={handleChange}
                                placeholder="Flat/House no, Building, Street, Area"
                                rows={3}
                            />
                        </div>
                    </div>

                    <div className="d-flex gap-2 mt-2">
                        <button type="submit" className="web_buttons" disabled={loading}>
                            {loading
                                ? isEditMode ? "Updating..." : "Saving..."
                                : isEditMode ? "Update Address" : "Save Address"}
                        </button>
                        {handleBackToAddresses && (
                            <button
                                type="button"
                                className="web_buttons"
                                onClick={handleBackToAddresses}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddressForm;
